import React from 'react'
import Control from '../store/control';
import FormAfo from './formAfo';

const SideFormLlo = () => {
  const type = Control.Get('type');

  switch(type) {
    case 'AFO':
      return <FormAfo/>;
    default:
      return null;
  }
}

export default SideFormLlo;
